var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_19546)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27 23.6668L27 6.3335L26.72 5.3735L27 6.3335L15.9993 9.54204V20.4583L27 23.6668Z",
    stroke: "#161616",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 6.3335V23.6668C28 23.8221 27.9639 23.9752 27.8944 24.114C27.825 24.2529 27.7242 24.3737 27.6 24.4668C27.4758 24.56 27.3316 24.6229 27.1789 24.6507C27.0261 24.6785 26.869 24.6703 26.72 24.6268L4.72 18.2102C4.51228 18.1496 4.32982 18.0233 4.2 17.8502C4.07018 17.6771 4 17.4665 4 17.2502V12.7502C4 12.5338 4.07018 12.3233 4.2 12.1502C4.32982 11.9771 4.51228 11.8507 4.72 11.7902L26.72 5.3735C26.869 5.33003 27.0261 5.32186 27.1789 5.34963C27.3316 5.3774 27.4758 5.44035 27.6 5.5335C27.7242 5.62664 27.825 5.74743 27.8944 5.88628C27.9639 6.02514 28 6.17825 28 6.3335V6.3335Z",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19.4582V24.0001C9 24.2653 9.10536 24.5197 9.29289 24.7072C9.48043 24.8948 9.73478 25.0001 10 25.0001H14C14.2652 25.0001 14.5196 24.8948 14.7071 24.7072C14.8946 24.5197 15 24.2653 15 24.0001V8.79199",
    stroke: "#9199A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_19546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.22759dd64e4c1f9b6f77b8e222691842.svg";
export { ForwardRef as ReactComponent };